<script setup lang="ts">
import type { PropsTab } from './types';

defineProps<PropsTab>();
</script>

<template>
	<input
		type="radio"
		class="top-tabs_tabInput top-unvisible"
		:id="tabsId + name"
		:name="tabsId"
		:value="name"
		:checked="active"
		:disabled="disabled"
	/>

	<label
		:class="{
			'top-tabs_tabLabel': true,
			'top-forms-focusable': true,
			'top-disabled': disabled,
		}"
		:for="tabsId + name"
	>
		<slot></slot>
	</label>
</template>

<style>
.top-tabs_tabLabel {
	color: var(--color-text-1);
	cursor: pointer;
	border-bottom: 2px solid transparent;
	padding: 14px 20px;
	position: relative;
	display: flex;
	align-items: center;
}

.top-tabs_tabLabel:hover {
	border-color: var(--color-line-2);
}

.top-tabs_tabInput:checked + .top-tabs_tabLabel {
	border-color: var(--color-line-primary-1);
	color: var(--color-text-primary);
}
</style>
